import React from 'react';

import Card from 'components/Card';
import { CreateAmadeusBookingMutation } from 'generated/graphql';
import OfferDetailsCard from 'pages/SelfBooking/OfferDetails';

interface Props {
  booking: CreateAmadeusBookingMutation['createAmadeusBooking'];
  hideRoomGuestCounts?: boolean;
}

const YourTripCard: React.FC<Props> = ({
  booking,
  hideRoomGuestCounts = false,
}) => {
  return (
    <Card className="h-fit">
      <div className="mb-4 flex items-center justify-between">
        <h2 className="text-base font-bold">Your Trip</h2>
      </div>

      {/* Reuse OfferDetailsCard with booking data only */}
      <OfferDetailsCard
        booking={booking}
        showRatesDetails={false}
        hideRoomGuestCounts={hideRoomGuestCounts}
      />
    </Card>
  );
};

export default YourTripCard;
